import { render, staticRenderFns } from "./Memorias.vue?vue&type=template&id=d73c6202&scoped=true&"
import script from "./Memorias.vue?vue&type=script&lang=js&"
export * from "./Memorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73c6202",
  null
  
)

export default component.exports